import type { StationDto } from './station.dto.js';

export const stationDeviceClaimStatusValues = [
  'active',
  'superseded',
  'failed',
  'expired',
] as const;
export type StationDeviceClaimStatus = (typeof stationDeviceClaimStatusValues)[number];

export interface StationDeviceClaimSummaryDto {
  id: string;
  deviceId: string;
  status: StationDeviceClaimStatus;
  authorizedAt: string;
  activatedAt: string | null;
  supersededAt: string | null;
  failedAt: string | null;
}

export interface StationDeviceClaimDto extends StationDeviceClaimSummaryDto {
  companyId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  previousDeviceClaimId: string | null;
  supersededByClaimId: string | null;
  recoveryReason: string;
  authorizedByUserId: string | null;
  authorizedByMembershipId: string | null;
  failureReason: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface RecoverableStationDto {
  station: StationDto;
  activeDeviceClaim: StationDeviceClaimSummaryDto | null;
}

export interface ListRecoverableStationsRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  page?: number;
  pageSize?: number;
}

export interface ListRecoverableStationsResponse {
  items: RecoverableStationDto[];
  page: number;
  pageSize: number;
  total: number;
}

export interface CreateStationRecoveryClaimRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  deviceId: string;
  reason: string;
  desktopReleaseChannel?: string;
  desktopAppVersion?: string;
}

export interface StationRecoveryGrantDto {
  claim: StationDeviceClaimDto;
  station: StationDto;
  issuedAt: string;
  expiresAt: string;
}

export interface CreateStationRecoveryClaimResponse {
  recoveryGrant: StationRecoveryGrantDto;
}

export interface FailStationRecoveryClaimRequest {
  companyId: string;
  claimId: string;
  deviceId: string;
  reason: string;
}

export interface FailStationRecoveryClaimResponse {
  claim: StationDeviceClaimDto;
}
